import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { observable, action, computed } from 'mobx';
var RequestedDocumentsDialogStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _class = /*#__PURE__*/function (_Store) {
  function RequestedDocumentsDialogStore() {
    var _this;
    _classCallCheck(this, RequestedDocumentsDialogStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RequestedDocumentsDialogStore, [].concat(args));
    _initializerDefineProperty(_this, "showing", _descriptor, _this);
    _initializerDefineProperty(_this, "documents", _descriptor2, _this);
    _initializerDefineProperty(_this, "submitted", _descriptor3, _this);
    return _this;
  }
  _inherits(RequestedDocumentsDialogStore, _Store);
  return _createClass(RequestedDocumentsDialogStore, [{
    key: "infoGatheringState",
    get: function get() {
      return this.rootStore.projectDetailsStore.infoGatheringState;
    }
  }, {
    key: "hasPendingDocuments",
    get: function get() {
      return this.documents.length > 0;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.getPendingAdHocItems().length === 0;
    }
  }, {
    key: "show",
    value: function show() {
      this.loadDocuments();
      this.showing = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.showing = false;
    }
  }, {
    key: "hideSubmitted",
    value: function hideSubmitted() {
      this.submitted = false;
    }
  }, {
    key: "loadDocuments",
    value: function loadDocuments() {
      if (this.documents.length === 0) {
        this.documents = this.getPendingAdHocItems();
      }
    }
  }, {
    key: "saveAndClose",
    value: function saveAndClose() {
      this.hide();
      this.documents = this.getPendingAdHocItems();
      this.submitted = true;
    }
  }, {
    key: "getPendingAdHocItems",
    value: function getPendingAdHocItems() {
      return this.infoGatheringState.itemViewModels.items.filter(function (_ref) {
        var item = _ref.item;
        return !item.completed && item.adHoc;
      });
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "documents", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "submitted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasPendingDocuments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPendingDocuments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "show", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hide", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideSubmitted", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "hideSubmitted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadDocuments", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "loadDocuments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveAndClose", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "saveAndClose"), _class.prototype), _class);
export { RequestedDocumentsDialogStore as default };
//# sourceMappingURL=RequestedDocumentDialogStore.js.map
